import axios from 'axios';
import config from '../config/config';

class ShiftApi {
    static getAvailableLocations() {
        return axios(`${config.server.endpoint}backend/shift/availableLocations`, {
            method: 'get'
        });
    }

    static addShift(repeatingShift, firstDay, lastDay, startAt, endAt, slots, overloadable, importance, location, comment) {
        return axios(`${config.server.endpoint}backend/shift/`, {
            method: 'post',
            data: {
                repeatingShift,
                firstDay,
                lastDay,
                startAt,
                endAt,
                slots,
                overloadable,
                importance,
                location,
                comment
            }
        })
    }
}

export default ShiftApi;
